// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"268":"Home","438":"Login"}[chunkId] || chunkId) + "." + {"268":"8bb720b7","438":"ff022b5d","479":"9adc4975"}[chunkId] + ".chunk.css";
};